import {gql} from "@apollo/client";
import {OrderAddressType} from "../../../../../graphql/types/OrderDetailType";

export const CHANGE_ORDER_RECIPIENT_CONTACT = gql`
    mutation ChangeOrderRecipientContact(
        $orderId: Long!
        $fullName: String!
        $phoneNumber: String!
        $countryCode: Int!
        $extension: String
    ) {
        changeOrderRecipientContact(
            orderId: $orderId
            fullName: $fullName
            phoneNumber: $phoneNumber
            countryCode: $countryCode
            extension: $extension
        ) {
            id
            fullName
            phoneNumber
            countryCode
            extension
        }
    }
`;

export interface ChangeOrderRecipientContactResponse {
    changeOrderRecipientContact: OrderAddressType;
}
